export { UserHistory } from "./History/UserHistory/Index";

export { HistoryCard } from './History/HistoryCards/Index';
export { Catalogs } from '../pages/Catalogs';
export { Inventory } from '../pages/Inventary/Index';
export { Roles } from './../pages/Roles';
export { UserManager } from './../pages/UsersManager';
export { RedirectComponent } from './../pages/Redirect';
export { HistorySam } from './History/HistorySam/Index'
export { Reassigment } from 'src/pages/Reassignment';
export { HistoryDevice } from './History/HistoryDevice/Index'
export { SandboxScreen } from './Sandbox/index'
